module.exports = __webpack_public_path__ + "static/images/company.057f5e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/company.png
// module id = hGfi
// module chunks = 0